<div>
  <c-smart-table [columnSorter]="true" [columns]="columns" [columnFilter]="true" [itemsPerPageSelect]="true"
    [itemsPerPage]="10" [items]="RetailCustomerTable" [tableBodyProps]="{ align: 'middle' }"
    [tableProps]="{ hover: true, striped: true, responsive: true }" header pagination></c-smart-table>
</div>